import {getheaders} from './authService';

async function requireOk(response) {
    if (response.ok) return response;
    const body = await response.json().catch(() => null);
    throw new Error(body?.message || body?.error || `Request failed (${response.status})`);
}

export async function getUserSessions(username) {
    const response = await fetch(`/api/auth/admin/users/${encodeURIComponent(username)}/sessions`, {
        method: 'GET',
        headers: getheaders(),
    });
    await requireOk(response);
    return response.json();
}

export async function revokeUserSessions(username) {
    const response = await fetch(`/api/auth/admin/users/${encodeURIComponent(username)}/sessions/revoke`, {
        method: 'POST',
        headers: getheaders(),
    });
    await requireOk(response);
    return response.json();
}

export async function revokeSession(sessionId) {
    const response = await fetch(`/api/auth/admin/sessions/${encodeURIComponent(sessionId)}/revoke`, {
        method: 'POST',
        headers: getheaders(),
    });
    await requireOk(response);
    return response.json();
}
